import * as React from 'react';

type UseMediaQueryOptions = {
  defaultValue?: boolean;
  initializeWithValue?: boolean;
};

export enum Breakpoint {
  SM = '(min-width: 640px)',
  MD = '(min-width: 768px)',
  LG = '(min-width: 1024px)',
  XL = '(min-width: 1280px)',
  XXL = '(min-width: 1536px)',
}

const IS_SERVER = typeof window === 'undefined';

export function useMediaQuery(
  query: string,
  {
    defaultValue = false,
    initializeWithValue = true,
  }: UseMediaQueryOptions = {},
): boolean {
  const getMatches = (queryString: string): boolean => {
    if (IS_SERVER) {
      return defaultValue;
    }
    return window.matchMedia(queryString).matches;
  };

  const [matches, setMatches] = React.useState<boolean>(() => {
    if (initializeWithValue) {
      return getMatches(query);
    }
    return defaultValue;
  });

  React.useEffect(() => {
    const matchMedia = window.matchMedia(query);

    const handleChange = () => {
      setMatches(matchMedia.matches);
    };

    handleChange();

    matchMedia.addEventListener('change', handleChange);

    return () => {
      matchMedia.removeEventListener('change', handleChange);
    };
  }, [query]);

  return matches;
}

export type { UseMediaQueryOptions };
